import { AccountTradesTab } from 'views/account/AccountTradesTab';

import { useAccountPageView } from './useAccountPageView';

export const AccountTradesRoute = () => {
    const { view } = useAccountPageView();
    return view === 'new' ? (
        <div className="pt-5">
            <AccountTradesTab layout="new" />
        </div>
    ) : (
        <AccountTradesTab />
    );
};
